import Base from '../../../src/js/classes/Base'

export default class FabLab extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {},
			options: {},
			classes: {},
			state: {},
		})
	}

	init() {
		this.addEvents()
	}

	addEvents() {}

	removeEvents() {}

	resize() {}

	update() {}

	unmount() {}
}
